import React from 'react';
import PropTypes from 'prop-types';

import ButtonFilter from '../ButtonFilter';
import styles from './styles.module.scss';

const ClearButton = ({ onClick }) => (
	<ButtonFilter
		onClick={onClick}
		icon="close"
		size="mobileSmall"
		text="Очистить"
		className={styles.ClearButton}
	/>
);

ClearButton.propTypes = {
	onClick: PropTypes.func
};

export default ClearButton;
